import React from 'react';

import Skeleton from '../../../../Skeleton';

export default {
  widgetInsightsGauge: (
    <div className="gauge-widget">
      <Skeleton height={114} width="100%" />
    </div>
  ),
  performanceSnapshot: <Skeleton height={122} width="100%" />,
};
